import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DriversService } from '../../../root/drivers.service';
import { DriverHSEScore } from '../../../types';

@Component({
  selector: 'lohi-safety',
  templateUrl: './safety.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SafetyComponent implements OnInit {
  public safety$: Observable<DriverHSEScore>;

  constructor(private driverService: DriversService) {}

  public ngOnInit(): void {
    this.safety$ = this.driverService.driverHSEScore$.pipe(filter((value) => !!value));
  }
}
